import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useGlobalKey} from "../../../../hooks/use-global-key.js";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import Button from "../../../../components/button/button.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import {Card} from "../../../../components/card/card.jsx";
import {Template} from "../../../../components/template/template.jsx";
import roleService from "../../../../services/web/role-service.js";
import {useQuery} from "@tanstack/react-query";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {navigateHook} from "../../../../hooks/use-navigate.js";

const RoleList = () => {
    const navigate = navigateHook();

    const [data, setData] = useState([])
    const [filter, setFilter] = useState("");

    const {data: dataFetch, isSuccess} = useQuery({
        queryFn: () => roleService.list(),
        queryKey: ["role-list"]
    });

    useEffect(() => {
        if (!isSuccess) return;

        setData(dataFetch);
    }, [isSuccess, dataFetch]);

    const [columnDefs,] = useState([
        { field: "name", headerName: "Nome", sort: "asc", flex: 1, comparator: aggridUtils.nullLastComparator},
        { field: "active_users", headerName: "Agentes ativos",  width: 150},
        { field: "inactive_users", headerName: "Agentes inativos",  width: 150},
    ]);

    const gridRef = useRef(undefined);

    const apply = useCallback(() => {
        setData(dataFetch?.filter(d => d.name?.toLowerCase().includes(filter?.toLowerCase())))
    }, [filter, dataFetch])

    const clear = useCallback(() => {
        setData(dataFetch);
        setFilter("");
    }, [dataFetch])

    useGlobalKey("Enter", apply);
    useGlobalKey("Escape", clear);

    const onCellClicked = ({data, event}) => {
        navigate(`/role/form/${data.id}`, event.ctrlKey)
    };

    return (
        <Template>
            <Template.Header>
                <Template.Title>Funções</Template.Title>

                <Button target={"primary"} onClick={() => navigate("/role/form")}>
                    <FaPlus/> Adicionar função
                </Button>
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body>
                        <div className="flex justify-between gap-4">
                            <InputForm
                                classNameWrapper={"w-full"}
                                id={"name"}
                                label={"Nome"}
                                name={"name"}
                                value={filter}
                                onChange={({target: {value}}) => setFilter(value)}
                            />

                            <div className={"flex gap-2"}>
                                <Button target={"default"} onClick={clear} title={"Limpar"}>
                                    <FaEraser />
                                </Button>
                                <Button onClick={apply} title={"Buscar"}>
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div style={{height: "calc(100vh - 153px)"}}>
                            <AgGridReact
                                ref={gridRef}
                                rowData={data ?? []}
                                columnDefs={columnDefs}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={aggridUtils.generalTheme()}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default RoleList;